import { React, useEffect, useState } from 'react';
import { Row, Col, Space, Tag, List, Radio, Calendar, Select } from 'antd';
import dayjs from 'dayjs';
import { CloseCircleOutlined } from '@ant-design/icons';


const SystemHolidayDetailPicker = ({
    year,
    holidayDatas,
    moreHolidayDatas,
    setHolidayDatas,
    setMoreHolidayDatas
}) => {
    const [mode, setMode] = useState()
    const selectDate = (date) => {
        let dateString = dayjs(date).format('YYYY-MM-DD')
        let isHoliday = holidayDatas.some((element) => { return element?.date === dateString })
        let inElseHoliday = moreHolidayDatas.some((element) => { return element?.date === dateString })

        if (isHoliday) {
            setHolidayDatas(pre => {
                return pre.map((element) => {
                    console.log({ element })
                    if (element?.date === dateString) {
                        return {
                            ...element,
                            isholiday: element.isholiday === "true" ? "false" : 'true'
                        }
                    }
                    else {
                        return {
                            ...element
                        }
                    }
                })
            })
        } else {
            if (inElseHoliday) {
                setMoreHolidayDatas(pre => {
                    return pre.filter((element) => {
                        return element?.date !== dateString
                    })
                })
            } else {
                setMoreHolidayDatas(pre => [...pre, {
                    "date": dateString,
                    "description": "自定假日"
                }])
            }
        }
    }
    useEffect(() => {

    }, []);
    return (
        <>
            <Col span={24}>
                <Row>
                    <Col lg={12} md={24} sm={24} xs={24}>
                        <Row>
                            <Col span={24}>
                                <Calendar
                                    locale="zh-tw"
                                    headerRender={({ value, type, onChange, onTypeChange }) => {
                                        const monthOptions = [];
                                        const months = [];
                                        for (let i = 0; i < 12; i++) {
                                            months.push(value.localeData().monthsShort(value.clone().month(i)));
                                        }
                                        for (let i = 0; i < 12; i++) {
                                            monthOptions.push(
                                                <Select.Option key={i} value={i} className="month-item">
                                                    {months[i]}
                                                </Select.Option>,
                                            );
                                        }
                                        const year = value.year();
                                        const month = value.month();
                                        return (
                                            <div
                                                style={{
                                                    padding: 8,
                                                }}
                                            >
                                                <Row gutter={8}>
                                                    <Col>
                                                        {year}
                                                    </Col>
                                                    <Col>
                                                        <Select
                                                            size="small"
                                                            popupMatchSelectWidth={false}
                                                            value={month}
                                                            onChange={(newMonth) => {
                                                                const now = value.clone().month(newMonth);
                                                                onChange(now);
                                                            }}
                                                        >
                                                            {monthOptions}
                                                        </Select>
                                                    </Col>
                                                    <Col>
                                                        <Radio.Group
                                                            size="small"
                                                            onChange={(e) => {
                                                                onTypeChange(e.target.value); setMode(e.target.value)
                                                            }}
                                                            value={type}
                                                        >
                                                            <Radio.Button value="month">月</Radio.Button>
                                                            <Radio.Button value="year">年</Radio.Button>
                                                        </Radio.Group>
                                                    </Col>
                                                </Row>
                                            </div>
                                        );
                                    }}
                                    mode={mode}
                                    validRange={[dayjs(`${year}-01-01`), dayjs(`${year}-12-31`)]}
                                    fullCellRender={(date, info) => {
                                        let holidayList = holidayDatas
                                            .filter(tmp => tmp?.isholiday === "true")
                                            .map(tmp => tmp?.date)
                                        return (
                                            <>
                                                {
                                                    info.type === "date" ?
                                                        <div
                                                            onClick={() => selectDate(date)}
                                                            style={{
                                                                backgroundColor: holidayList.includes(dayjs(date).format('YYYY-MM-DD')) ?
                                                                    "#FAD396"
                                                                    :
                                                                    moreHolidayDatas.some((element) => { return element?.date === dayjs(date).format('YYYY-MM-DD') }) ?
                                                                        "#C3F6FA"
                                                                        :
                                                                        "#fff"
                                                            }}
                                                        >
                                                            {dayjs(date).format("DD")}
                                                        </div>
                                                        :
                                                        <div onClick={() => setMode("month")}>
                                                            {dayjs(date).format("M[月]")}
                                                        </div>
                                                }
                                            </>
                                        )
                                    }}
                                    style={{ paddingInline: "5%" }}
                                    fullscreen={false}
                                />
                            </Col>
                            <Col span={24}>
                                <Row gutter={[4, 4]}>
                                    <Col span={24}>
                                        其他放假日:
                                    </Col>
                                    <Col span={24}>
                                        <Row>
                                            <Space
                                                direction="horizontal"
                                                wrap
                                            >
                                                {moreHolidayDatas.map(tmp => <>
                                                    <Tag
                                                    closeIcon={<CloseCircleOutlined
                                                        style={{
                                                            color:"#000"
                                                        }}
                                                        />}
                                                    style={{
                                                        color:"#000"
                                                    }}
                                                        color='#c2f6fa'
                                                        key={tmp?.date}
                                                        closable
                                                        onClose={(event) => {
                                                            console.log(event)
                                                            setMoreHolidayDatas((pre) => {
                                                                let temp = pre.filter(element => element?.date !== tmp?.date)
                                                                return temp
                                                            })
                                                        }}>
                                                        {tmp?.date}
                                                    </Tag>
                                                </>)}
                                            </Space>
                                        </Row>
                                    </Col>

                                </Row>
                            </Col>
                        </Row>

                    </Col>
                    <Col lg={12} md={24} sm={24} xs={24}>
                        <List
                            dataSource={holidayDatas}
                            renderItem={(item, index) => (
                                <List.Item style={{ paddingInline: "1%" }}>
                                    <Col span={12}>
                                        <Row justify={"space-between"}>
                                            <Col>
                                                {item?.description}：
                                            </Col>
                                            <Col>
                                                {item?.date}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={1}>
                                    </Col>
                                    <Col span={3}>
                                        放假：
                                    </Col>
                                    <Col span={8}>
                                        <Radio.Group
                                            value={item?.isholiday}
                                            options={[
                                                {
                                                    label: "是",
                                                    value: "true"
                                                },
                                                {
                                                    label: "否",
                                                    value: "false"
                                                }
                                            ]}
                                            onChange={(e) => setHolidayDatas(pre => {
                                                pre[index].isholiday = e.target.value;
                                                return [...pre]
                                            })}
                                        />
                                    </Col>
                                </List.Item>
                            )}
                        />
                    </Col>
                </Row>
            </Col>
        </>
    )
}
export default SystemHolidayDetailPicker;